// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_MORE_DISCUSSIONS_FROM_topic = "Viac z %(topic)s";
export const FORUM_RECENT_POSTS = "Najnov\u0161ie ot\u00e1zky z poradne";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskusie";
